import React from 'react';
import AddPaymentSettingComponent from '../../../Components/PaymentSetting/AddPaymentSetting';

export default function AddPaymentSetting() {
    return (
        <div className='page-body'>
            <AddPaymentSettingComponent />
        </div>
    );
}